import React from 'react';
import emailjs from 'emailjs-com';
import contactImage from '../../images/contactImage.jpg';
import './Contact.css';
const Contact = () => {


    const sendEmail = (e) => {
        e.preventDefault();

        emailjs.sendForm('service_pdsrrt5', 'template_x9q0lu7', e.target, 'user_Q8A1WBeQTtddbCaCaLurG')
            .then((result) => {
                console.log(result.text);
            }, (error) => {
                console.log(error.text);
            });
        e.target.reset();
        alert('Message sent!')
    }

    return (
        <div className='contact' id='contact'>
            <div className='contact__title'>Contact</div>
            <div className='contact__border'></div>
            <div className='contact__descrip'>For more info and support contact us</div>
            <div className='contact__content'>
                <div className='contact__form'>
                    <form onSubmit={sendEmail}>
                        <div>
                            <input type="text" className="form-control " placeholder='Name' name='name' required />
                        </div>

                        <div className='mt-4'>
                            <input type="email" className="form-control" placeholder="Email" name='email' required />
                        </div>

                        <div className='mt-4'>
                            <textarea className="" rows="4" placeholder="Type Something..." name='message' required></textarea>
                        </div>

                        <div className='mt-4'>
                            <button className="contact__send" type="submit">Send</button>
                        </div>

                    </form>
                </div>

                <div className='contact__contact'>
                    <div className='Contact__direct'>
                        <i className="fas fa-thumbtack"></i>
                        <p>KN 74 Street, Kigali Rwanda</p>
                    </div>

                    <div className='Contact__direct'>
                        <i className="fas fa-envelope"></i>
                        <a href='mailto:info@retbin.com'>Mail us</a>
                    </div>

                    <div className='Contact__direct'>
                        <i className="fas fa-phone-alt"></i>
                        <a href='tel:+250780257333'>Call us</a>
                    </div>
                    <div className='Contact__image'>
                        <img src={contactImage} alt='retbin' />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Contact
